import { render, staticRenderFns } from "./ActivityNewModal.vue?vue&type=template&id=3422705b&scoped=true"
import script from "./ActivityNewModal.vue?vue&type=script&lang=ts"
export * from "./ActivityNewModal.vue?vue&type=script&lang=ts"
import style0 from "./ActivityNewModal.vue?vue&type=style&index=0&id=3422705b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3422705b",
  null
  
)

export default component.exports